module.exports = __webpack_public_path__ + "static/media/bell.415f7507.svg";